import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const NAV_ITEMS = [
  { id: 'work', label: 'Work' },
  { id: 'our-story', label: 'Our Story' },
  { id: 'dogs', label: 'The Dogs' },
];

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const NavLinks = ({ onNavigate }) => (
  <div className="hidden md:flex items-center gap-10">
    {NAV_ITEMS.map((item) => (
      <button
        key={item.id}
        onClick={() => { scrollToSection(item.id); onNavigate?.(); }}
        className="text-[#F0EDE8]/60 hover:text-[#14B8A6] transition-colors text-sm uppercase tracking-[0.15em]"
        data-testid={`nav-${item.id}`}
      >
        {item.label}
      </button>
    ))}
    <button
      onClick={() => { scrollToSection('contact'); onNavigate?.(); }}
      className="bg-[#14B8A6] hover:bg-[#0D9488] text-[#0A0A0B] font-medium px-6 py-2.5 text-sm uppercase tracking-[0.12em] transition-all duration-300 hover:shadow-lg hover:shadow-[#14B8A6]/20"
      data-testid="nav-contact"
    >
      Contact
    </button>
  </div>
);

const MobileMenu = ({ onNavigate }) => (
  <div className="md:hidden mt-4 pb-4 space-y-4 border-t border-[#3d2a5c]/20 pt-4" data-testid="mobile-menu">
    {NAV_ITEMS.map((item) => (
      <button
        key={item.id}
        onClick={() => { scrollToSection(item.id); onNavigate(); }}
        className="block w-full text-left text-[#F0EDE8]/60 hover:text-[#14B8A6] transition-colors text-sm uppercase tracking-[0.15em] py-2"
      >
        {item.label}
      </button>
    ))}
    <button
      onClick={() => { scrollToSection('contact'); onNavigate(); }}
      className="block w-full text-left text-[#14B8A6] text-sm uppercase tracking-[0.15em] py-2"
    >
      Contact
    </button>
  </div>
);

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMobile = () => setMobileMenuOpen(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0B]/85 backdrop-blur-md border-b border-[#3d2a5c]/20">
      <nav className="container mx-auto px-6 py-4" data-testid="main-nav">
        <div className="flex items-center justify-between">
          <button
            onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); closeMobile(); }}
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
            data-testid="nav-logo"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_whisky-woven/artifacts/95vr4ijj_Whisky%20Woven%20BLue%20Logo%20SVG.png"
              alt="Whisky Woven Logo"
              className="h-20 md:h-24 w-auto object-contain"
            />
          </button>
          <NavLinks />
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-[#F0EDE8]/70 hover:text-[#14B8A6] transition-colors"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        {mobileMenuOpen && <MobileMenu onNavigate={closeMobile} />}
      </nav>
    </header>
  );
};

export default Header;
